<template>
  <v-sheet v-bind="$attrs" v-on="$listeners">
    <bootcamp-meeting-loader></bootcamp-meeting-loader>
    <v-row v-if="!loading" align="center" justify="center">
      <v-col cols="auto">
        <v-list>
          <v-list-item v-for="event in events" :key="event.id">
            <v-list-item-action-text class="pr-3">
              <v-btn text class="primary--text display-1" :href="event.link">{{event.date.format('h:mma')}}</v-btn>
            </v-list-item-action-text>
            <v-list-item-content>
              <v-list-item-title>
                <span class="body-1">{{event.date.format('ddd, MMMM Do')}}</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="caption">{{event.oneline || event.link}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn :disabled="event.date.isBefore(cutoff)" x-large color="secondary" :href="event.link">GO</v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
  import BootcampMeetingLoader from "@/components/bootcamp-meeting-loader.vue"
  import {mapState, mapGetters} from 'vuex'

  export default {
    name: "BootcampMeeting",
    components: {BootcampMeetingLoader},
    computed: {
      ...mapState({
        globalRefresh: 'refresh'
      }),

      ...mapState('workout', {
        events: 'active',
        loading: 'loading',
        cutoff: 'cutoffDate'
      }),
      // events() {
      //   const events = [].concat(this.workouts, this.hangouts)
      //   events.sort((a, b) => a.date.isBefore(b))
      //   return events
      // },
      // loading() {
      //   return !!this.loadingWorkouts || !!this.loadingHangouts
      // },
      e() {
        return this.$store.state.workout.active
      }
    }
  }
</script>

<style scoped>

</style>
